// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"ViewSliderMobileContainerType_modal-scroll__v_giI","slider-container":"ViewSliderMobileContainerType_slider-container__oOq03"};